// source: datalake.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.datalake.ActivePipeline', null, global);
goog.exportSymbol('proto.datalake.ActivePipelinesResponse', null, global);
goog.exportSymbol('proto.datalake.AddAnnotationsToBatchRequest', null, global);
goog.exportSymbol('proto.datalake.AddAnnotationsToBatchRequest.JsonInputCase', null, global);
goog.exportSymbol('proto.datalake.AddAnnotationsToBatchResponse', null, global);
goog.exportSymbol('proto.datalake.AddAugmentationRequest', null, global);
goog.exportSymbol('proto.datalake.AddAugmentationRequest.JsonInputCase', null, global);
goog.exportSymbol('proto.datalake.AddAugmentationResponse', null, global);
goog.exportSymbol('proto.datalake.CancelPipelineRequest', null, global);
goog.exportSymbol('proto.datalake.CancelPipelineResponse', null, global);
goog.exportSymbol('proto.datalake.DataCurationPipelineRequest', null, global);
goog.exportSymbol('proto.datalake.DataCurationPipelineResponse', null, global);
goog.exportSymbol('proto.datalake.DataCurationPipelineResponse.UpdateType', null, global);
goog.exportSymbol('proto.datalake.DeleteImagesRequest', null, global);
goog.exportSymbol('proto.datalake.DeleteImagesResponse', null, global);
goog.exportSymbol('proto.datalake.GetAllGroupsResponse', null, global);
goog.exportSymbol('proto.datalake.GetCollectionMetadataRequest', null, global);
goog.exportSymbol('proto.datalake.GetCollectionMetadataResponse', null, global);
goog.exportSymbol('proto.datalake.GetCollectionMetadataTextRequest', null, global);
goog.exportSymbol('proto.datalake.GetCropGroupsRequest', null, global);
goog.exportSymbol('proto.datalake.GetCropGroupsResponse', null, global);
goog.exportSymbol('proto.datalake.GetGroupMetadataRequest', null, global);
goog.exportSymbol('proto.datalake.GetGroupMetadataResponse', null, global);
goog.exportSymbol('proto.datalake.GetImageGSDRequest', null, global);
goog.exportSymbol('proto.datalake.GetImageGSDResponse', null, global);
goog.exportSymbol('proto.datalake.GetImageMetadataRequest', null, global);
goog.exportSymbol('proto.datalake.GetImageMetadataResponse', null, global);
goog.exportSymbol('proto.datalake.GroupHistoryRequest', null, global);
goog.exportSymbol('proto.datalake.GroupHistoryResponse', null, global);
goog.exportSymbol('proto.datalake.GroupInfo', null, global);
goog.exportSymbol('proto.datalake.HealthCheckResponse', null, global);
goog.exportSymbol('proto.datalake.KeyValue', null, global);
goog.exportSymbol('proto.datalake.PipelineHistoryItem', null, global);
goog.exportSymbol('proto.datalake.PipelineHistoryRequest', null, global);
goog.exportSymbol('proto.datalake.PipelineHistoryResponse', null, global);
goog.exportSymbol('proto.datalake.PipelineStatusRequest', null, global);
goog.exportSymbol('proto.datalake.PipelineStatusResponse', null, global);
goog.exportSymbol('proto.datalake.PullDatasetRequest', null, global);
goog.exportSymbol('proto.datalake.PullDatasetResponse', null, global);
goog.exportSymbol('proto.datalake.PullGroupRequest', null, global);
goog.exportSymbol('proto.datalake.PullGroupResponse', null, global);
goog.exportSymbol('proto.datalake.QueryImagesRequest', null, global);
goog.exportSymbol('proto.datalake.QueryImagesResponse', null, global);
goog.exportSymbol('proto.datalake.QueryInGroupRequest', null, global);
goog.exportSymbol('proto.datalake.QueryInGroupResponse', null, global);
goog.exportSymbol('proto.datalake.QueryableAttributesResponse', null, global);
goog.exportSymbol('proto.datalake.RegisterAnnotationBatchRequest', null, global);
goog.exportSymbol('proto.datalake.RegisterAnnotationBatchResponse', null, global);
goog.exportSymbol('proto.datalake.RegisterDatasetRequest', null, global);
goog.exportSymbol('proto.datalake.RegisterDatasetRequest.BatchIdsInputCase', null, global);
goog.exportSymbol('proto.datalake.RegisterDatasetResponse', null, global);
goog.exportSymbol('proto.datalake.RegisterImagesRequest', null, global);
goog.exportSymbol('proto.datalake.RegisterImagesResponse', null, global);
goog.exportSymbol('proto.datalake.SelectImagesRequest', null, global);
goog.exportSymbol('proto.datalake.SelectImagesResponse', null, global);
goog.exportSymbol('proto.datalake.UpdateImagesRequest', null, global);
goog.exportSymbol('proto.datalake.UpdateImagesResponse', null, global);
goog.exportSymbol('proto.datalake.WatchPipelineRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.KeyValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.KeyValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.KeyValue.displayName = 'proto.datalake.KeyValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.HealthCheckResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.HealthCheckResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.HealthCheckResponse.displayName = 'proto.datalake.HealthCheckResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.SelectImagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.SelectImagesRequest.repeatedFields_, null);
};
goog.inherits(proto.datalake.SelectImagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.SelectImagesRequest.displayName = 'proto.datalake.SelectImagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.SelectImagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.SelectImagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.SelectImagesResponse.displayName = 'proto.datalake.SelectImagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.QueryImagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.QueryImagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.QueryImagesRequest.displayName = 'proto.datalake.QueryImagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.QueryImagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.QueryImagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.QueryImagesResponse.displayName = 'proto.datalake.QueryImagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.QueryableAttributesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.QueryableAttributesResponse.repeatedFields_, null);
};
goog.inherits(proto.datalake.QueryableAttributesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.QueryableAttributesResponse.displayName = 'proto.datalake.QueryableAttributesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.RegisterAnnotationBatchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.RegisterAnnotationBatchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.RegisterAnnotationBatchRequest.displayName = 'proto.datalake.RegisterAnnotationBatchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.RegisterAnnotationBatchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.RegisterAnnotationBatchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.RegisterAnnotationBatchResponse.displayName = 'proto.datalake.RegisterAnnotationBatchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PullGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.PullGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PullGroupRequest.displayName = 'proto.datalake.PullGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PullGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.PullGroupResponse.repeatedFields_, null);
};
goog.inherits(proto.datalake.PullGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PullGroupResponse.displayName = 'proto.datalake.PullGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GroupInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GroupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GroupInfo.displayName = 'proto.datalake.GroupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetAllGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.GetAllGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.datalake.GetAllGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetAllGroupsResponse.displayName = 'proto.datalake.GetAllGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetCropGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetCropGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetCropGroupsRequest.displayName = 'proto.datalake.GetCropGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetCropGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.GetCropGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.datalake.GetCropGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetCropGroupsResponse.displayName = 'proto.datalake.GetCropGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.AddAnnotationsToBatchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.datalake.AddAnnotationsToBatchRequest.oneofGroups_);
};
goog.inherits(proto.datalake.AddAnnotationsToBatchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.AddAnnotationsToBatchRequest.displayName = 'proto.datalake.AddAnnotationsToBatchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.AddAnnotationsToBatchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.AddAnnotationsToBatchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.AddAnnotationsToBatchResponse.displayName = 'proto.datalake.AddAnnotationsToBatchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GroupHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GroupHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GroupHistoryRequest.displayName = 'proto.datalake.GroupHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GroupHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GroupHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GroupHistoryResponse.displayName = 'proto.datalake.GroupHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetImageGSDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetImageGSDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetImageGSDRequest.displayName = 'proto.datalake.GetImageGSDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetImageGSDResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetImageGSDResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetImageGSDResponse.displayName = 'proto.datalake.GetImageGSDResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.UpdateImagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.UpdateImagesRequest.repeatedFields_, null);
};
goog.inherits(proto.datalake.UpdateImagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.UpdateImagesRequest.displayName = 'proto.datalake.UpdateImagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.UpdateImagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.UpdateImagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.UpdateImagesResponse.displayName = 'proto.datalake.UpdateImagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.DeleteImagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.DeleteImagesRequest.repeatedFields_, null);
};
goog.inherits(proto.datalake.DeleteImagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.DeleteImagesRequest.displayName = 'proto.datalake.DeleteImagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.DeleteImagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.DeleteImagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.DeleteImagesResponse.displayName = 'proto.datalake.DeleteImagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.RegisterImagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.RegisterImagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.RegisterImagesRequest.displayName = 'proto.datalake.RegisterImagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.RegisterImagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.RegisterImagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.RegisterImagesResponse.displayName = 'proto.datalake.RegisterImagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetImageMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetImageMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetImageMetadataRequest.displayName = 'proto.datalake.GetImageMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetImageMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetImageMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetImageMetadataResponse.displayName = 'proto.datalake.GetImageMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetCollectionMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetCollectionMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetCollectionMetadataRequest.displayName = 'proto.datalake.GetCollectionMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetCollectionMetadataTextRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetCollectionMetadataTextRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetCollectionMetadataTextRequest.displayName = 'proto.datalake.GetCollectionMetadataTextRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetCollectionMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetCollectionMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetCollectionMetadataResponse.displayName = 'proto.datalake.GetCollectionMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.QueryInGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.QueryInGroupRequest.repeatedFields_, null);
};
goog.inherits(proto.datalake.QueryInGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.QueryInGroupRequest.displayName = 'proto.datalake.QueryInGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.QueryInGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.QueryInGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.QueryInGroupResponse.displayName = 'proto.datalake.QueryInGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetGroupMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetGroupMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetGroupMetadataRequest.displayName = 'proto.datalake.GetGroupMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.GetGroupMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.GetGroupMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.GetGroupMetadataResponse.displayName = 'proto.datalake.GetGroupMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.RegisterDatasetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.datalake.RegisterDatasetRequest.oneofGroups_);
};
goog.inherits(proto.datalake.RegisterDatasetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.RegisterDatasetRequest.displayName = 'proto.datalake.RegisterDatasetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.RegisterDatasetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.RegisterDatasetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.RegisterDatasetResponse.displayName = 'proto.datalake.RegisterDatasetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PullDatasetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.PullDatasetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PullDatasetRequest.displayName = 'proto.datalake.PullDatasetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PullDatasetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.PullDatasetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PullDatasetResponse.displayName = 'proto.datalake.PullDatasetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.AddAugmentationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.datalake.AddAugmentationRequest.oneofGroups_);
};
goog.inherits(proto.datalake.AddAugmentationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.AddAugmentationRequest.displayName = 'proto.datalake.AddAugmentationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.AddAugmentationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.AddAugmentationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.AddAugmentationResponse.displayName = 'proto.datalake.AddAugmentationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.DataCurationPipelineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.DataCurationPipelineRequest.repeatedFields_, null);
};
goog.inherits(proto.datalake.DataCurationPipelineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.DataCurationPipelineRequest.displayName = 'proto.datalake.DataCurationPipelineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.DataCurationPipelineResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.DataCurationPipelineResponse.repeatedFields_, null);
};
goog.inherits(proto.datalake.DataCurationPipelineResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.DataCurationPipelineResponse.displayName = 'proto.datalake.DataCurationPipelineResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PipelineStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.PipelineStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PipelineStatusRequest.displayName = 'proto.datalake.PipelineStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PipelineStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.PipelineStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PipelineStatusResponse.displayName = 'proto.datalake.PipelineStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.WatchPipelineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.WatchPipelineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.WatchPipelineRequest.displayName = 'proto.datalake.WatchPipelineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.ActivePipelinesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.ActivePipelinesResponse.repeatedFields_, null);
};
goog.inherits(proto.datalake.ActivePipelinesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.ActivePipelinesResponse.displayName = 'proto.datalake.ActivePipelinesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.ActivePipeline = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.ActivePipeline, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.ActivePipeline.displayName = 'proto.datalake.ActivePipeline';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PipelineHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.PipelineHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PipelineHistoryRequest.displayName = 'proto.datalake.PipelineHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PipelineHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.datalake.PipelineHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.datalake.PipelineHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PipelineHistoryResponse.displayName = 'proto.datalake.PipelineHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.PipelineHistoryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.PipelineHistoryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.PipelineHistoryItem.displayName = 'proto.datalake.PipelineHistoryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.CancelPipelineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.CancelPipelineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.CancelPipelineRequest.displayName = 'proto.datalake.CancelPipelineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.datalake.CancelPipelineResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.datalake.CancelPipelineResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.datalake.CancelPipelineResponse.displayName = 'proto.datalake.CancelPipelineResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.KeyValue.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.KeyValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.KeyValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.KeyValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.KeyValue}
 */
proto.datalake.KeyValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.KeyValue;
  return proto.datalake.KeyValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.KeyValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.KeyValue}
 */
proto.datalake.KeyValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.KeyValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.KeyValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.KeyValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.KeyValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.datalake.KeyValue.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.KeyValue} returns this
 */
proto.datalake.KeyValue.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.datalake.KeyValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.KeyValue} returns this
 */
proto.datalake.KeyValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.HealthCheckResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.HealthCheckResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.HealthCheckResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.HealthCheckResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    healthy: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    version: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.HealthCheckResponse}
 */
proto.datalake.HealthCheckResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.HealthCheckResponse;
  return proto.datalake.HealthCheckResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.HealthCheckResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.HealthCheckResponse}
 */
proto.datalake.HealthCheckResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHealthy(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.HealthCheckResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.HealthCheckResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.HealthCheckResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.HealthCheckResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHealthy();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional bool healthy = 1;
 * @return {boolean}
 */
proto.datalake.HealthCheckResponse.prototype.getHealthy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.HealthCheckResponse} returns this
 */
proto.datalake.HealthCheckResponse.prototype.setHealthy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.datalake.HealthCheckResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.HealthCheckResponse} returns this
 */
proto.datalake.HealthCheckResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string version = 3;
 * @return {string}
 */
proto.datalake.HealthCheckResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.HealthCheckResponse} returns this
 */
proto.datalake.HealthCheckResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 timestamp = 4;
 * @return {number}
 */
proto.datalake.HealthCheckResponse.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.HealthCheckResponse} returns this
 */
proto.datalake.HealthCheckResponse.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.SelectImagesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.SelectImagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.SelectImagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.SelectImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.SelectImagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    criteriaList: jspb.Message.toObjectList(msg.getCriteriaList(),
    proto.datalake.KeyValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.SelectImagesRequest}
 */
proto.datalake.SelectImagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.SelectImagesRequest;
  return proto.datalake.SelectImagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.SelectImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.SelectImagesRequest}
 */
proto.datalake.SelectImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.KeyValue;
      reader.readMessage(value,proto.datalake.KeyValue.deserializeBinaryFromReader);
      msg.addCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.SelectImagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.SelectImagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.SelectImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.SelectImagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCriteriaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.KeyValue.serializeBinaryToWriter
    );
  }
};


/**
 * repeated KeyValue criteria = 1;
 * @return {!Array<!proto.datalake.KeyValue>}
 */
proto.datalake.SelectImagesRequest.prototype.getCriteriaList = function() {
  return /** @type{!Array<!proto.datalake.KeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.KeyValue, 1));
};


/**
 * @param {!Array<!proto.datalake.KeyValue>} value
 * @return {!proto.datalake.SelectImagesRequest} returns this
*/
proto.datalake.SelectImagesRequest.prototype.setCriteriaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.KeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.KeyValue}
 */
proto.datalake.SelectImagesRequest.prototype.addCriteria = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.KeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.SelectImagesRequest} returns this
 */
proto.datalake.SelectImagesRequest.prototype.clearCriteriaList = function() {
  return this.setCriteriaList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.SelectImagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.SelectImagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.SelectImagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.SelectImagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.SelectImagesResponse}
 */
proto.datalake.SelectImagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.SelectImagesResponse;
  return proto.datalake.SelectImagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.SelectImagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.SelectImagesResponse}
 */
proto.datalake.SelectImagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.SelectImagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.SelectImagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.SelectImagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.SelectImagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.SelectImagesResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.SelectImagesResponse} returns this
 */
proto.datalake.SelectImagesResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.SelectImagesResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.SelectImagesResponse} returns this
 */
proto.datalake.SelectImagesResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.SelectImagesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.SelectImagesResponse} returns this
 */
proto.datalake.SelectImagesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.QueryImagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.QueryImagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.QueryImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryImagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.QueryImagesRequest}
 */
proto.datalake.QueryImagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.QueryImagesRequest;
  return proto.datalake.QueryImagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.QueryImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.QueryImagesRequest}
 */
proto.datalake.QueryImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.QueryImagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.QueryImagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.QueryImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryImagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.datalake.QueryImagesRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.QueryImagesRequest} returns this
 */
proto.datalake.QueryImagesRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.QueryImagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.QueryImagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.QueryImagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryImagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.QueryImagesResponse}
 */
proto.datalake.QueryImagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.QueryImagesResponse;
  return proto.datalake.QueryImagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.QueryImagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.QueryImagesResponse}
 */
proto.datalake.QueryImagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.QueryImagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.QueryImagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.QueryImagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryImagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.QueryImagesResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.QueryImagesResponse} returns this
 */
proto.datalake.QueryImagesResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.QueryImagesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.QueryImagesResponse} returns this
 */
proto.datalake.QueryImagesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.QueryableAttributesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.QueryableAttributesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.QueryableAttributesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.QueryableAttributesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryableAttributesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    attributesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.QueryableAttributesResponse}
 */
proto.datalake.QueryableAttributesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.QueryableAttributesResponse;
  return proto.datalake.QueryableAttributesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.QueryableAttributesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.QueryableAttributesResponse}
 */
proto.datalake.QueryableAttributesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAttributes(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.QueryableAttributesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.QueryableAttributesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.QueryableAttributesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryableAttributesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated string attributes = 1;
 * @return {!Array<string>}
 */
proto.datalake.QueryableAttributesResponse.prototype.getAttributesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.datalake.QueryableAttributesResponse} returns this
 */
proto.datalake.QueryableAttributesResponse.prototype.setAttributesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.datalake.QueryableAttributesResponse} returns this
 */
proto.datalake.QueryableAttributesResponse.prototype.addAttributes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.QueryableAttributesResponse} returns this
 */
proto.datalake.QueryableAttributesResponse.prototype.clearAttributesList = function() {
  return this.setAttributesList([]);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.QueryableAttributesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.QueryableAttributesResponse} returns this
 */
proto.datalake.QueryableAttributesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.RegisterAnnotationBatchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.RegisterAnnotationBatchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterAnnotationBatchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    s3Uri: jspb.Message.getFieldWithDefault(msg, 1, ""),
    uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    creator: jspb.Message.getFieldWithDefault(msg, 3, ""),
    purpose: jspb.Message.getFieldWithDefault(msg, 4, ""),
    parentId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isFinal: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isOriginal: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    vendorName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    annotationType: jspb.Message.getFieldWithDefault(msg, 9, ""),
    annotationFormat: jspb.Message.getFieldWithDefault(msg, 10, ""),
    classesNumber: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.RegisterAnnotationBatchRequest}
 */
proto.datalake.RegisterAnnotationBatchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.RegisterAnnotationBatchRequest;
  return proto.datalake.RegisterAnnotationBatchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.RegisterAnnotationBatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.RegisterAnnotationBatchRequest}
 */
proto.datalake.RegisterAnnotationBatchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Uri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurpose(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFinal(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOriginal(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnotationType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnotationFormat(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClassesNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.RegisterAnnotationBatchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.RegisterAnnotationBatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterAnnotationBatchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getS3Uri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPurpose();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsFinal();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsOriginal();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getVendorName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAnnotationType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAnnotationFormat();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getClassesNumber();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional string s3_uri = 1;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string creator = 3;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string purpose = 4;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getPurpose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string parent_id = 5;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_final = 6;
 * @return {boolean}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getIsFinal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setIsFinal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_original = 7;
 * @return {boolean}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getIsOriginal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setIsOriginal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string vendor_name = 8;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getVendorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setVendorName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string annotation_type = 9;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getAnnotationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setAnnotationType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string annotation_format = 10;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getAnnotationFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setAnnotationFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 classes_number = 11;
 * @return {number}
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.getClassesNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.RegisterAnnotationBatchRequest} returns this
 */
proto.datalake.RegisterAnnotationBatchRequest.prototype.setClassesNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.RegisterAnnotationBatchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.RegisterAnnotationBatchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterAnnotationBatchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.RegisterAnnotationBatchResponse}
 */
proto.datalake.RegisterAnnotationBatchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.RegisterAnnotationBatchResponse;
  return proto.datalake.RegisterAnnotationBatchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.RegisterAnnotationBatchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.RegisterAnnotationBatchResponse}
 */
proto.datalake.RegisterAnnotationBatchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.RegisterAnnotationBatchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.RegisterAnnotationBatchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterAnnotationBatchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchResponse} returns this
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterAnnotationBatchResponse} returns this
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.RegisterAnnotationBatchResponse} returns this
 */
proto.datalake.RegisterAnnotationBatchResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PullGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PullGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PullGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PullGroupRequest}
 */
proto.datalake.PullGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PullGroupRequest;
  return proto.datalake.PullGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PullGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PullGroupRequest}
 */
proto.datalake.PullGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PullGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PullGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PullGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.datalake.PullGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PullGroupRequest} returns this
 */
proto.datalake.PullGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.PullGroupResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PullGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PullGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PullGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    s3LinksList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PullGroupResponse}
 */
proto.datalake.PullGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PullGroupResponse;
  return proto.datalake.PullGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PullGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PullGroupResponse}
 */
proto.datalake.PullGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addS3Links(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PullGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PullGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PullGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getS3LinksList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated string s3_links = 1;
 * @return {!Array<string>}
 */
proto.datalake.PullGroupResponse.prototype.getS3LinksList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.datalake.PullGroupResponse} returns this
 */
proto.datalake.PullGroupResponse.prototype.setS3LinksList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.datalake.PullGroupResponse} returns this
 */
proto.datalake.PullGroupResponse.prototype.addS3Links = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.PullGroupResponse} returns this
 */
proto.datalake.PullGroupResponse.prototype.clearS3LinksList = function() {
  return this.setS3LinksList([]);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.PullGroupResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.PullGroupResponse} returns this
 */
proto.datalake.PullGroupResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.PullGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PullGroupResponse} returns this
 */
proto.datalake.PullGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GroupInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GroupInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GroupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GroupInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    purpose: jspb.Message.getFieldWithDefault(msg, 2, ""),
    s3Location: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GroupInfo}
 */
proto.datalake.GroupInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GroupInfo;
  return proto.datalake.GroupInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GroupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GroupInfo}
 */
proto.datalake.GroupInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurpose(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Location(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GroupInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GroupInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GroupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GroupInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPurpose();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getS3Location();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.datalake.GroupInfo.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GroupInfo} returns this
 */
proto.datalake.GroupInfo.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string purpose = 2;
 * @return {string}
 */
proto.datalake.GroupInfo.prototype.getPurpose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GroupInfo} returns this
 */
proto.datalake.GroupInfo.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string s3_location = 3;
 * @return {string}
 */
proto.datalake.GroupInfo.prototype.getS3Location = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GroupInfo} returns this
 */
proto.datalake.GroupInfo.prototype.setS3Location = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.GetAllGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetAllGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetAllGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetAllGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetAllGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.datalake.GroupInfo.toObject, includeInstance),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetAllGroupsResponse}
 */
proto.datalake.GetAllGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetAllGroupsResponse;
  return proto.datalake.GetAllGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetAllGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetAllGroupsResponse}
 */
proto.datalake.GetAllGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.GroupInfo;
      reader.readMessage(value,proto.datalake.GroupInfo.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetAllGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetAllGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetAllGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetAllGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.GroupInfo.serializeBinaryToWriter
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated GroupInfo groups = 1;
 * @return {!Array<!proto.datalake.GroupInfo>}
 */
proto.datalake.GetAllGroupsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.datalake.GroupInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.GroupInfo, 1));
};


/**
 * @param {!Array<!proto.datalake.GroupInfo>} value
 * @return {!proto.datalake.GetAllGroupsResponse} returns this
*/
proto.datalake.GetAllGroupsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.GroupInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.GroupInfo}
 */
proto.datalake.GetAllGroupsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.GroupInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.GetAllGroupsResponse} returns this
 */
proto.datalake.GetAllGroupsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.GetAllGroupsResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.GetAllGroupsResponse} returns this
 */
proto.datalake.GetAllGroupsResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetCropGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetCropGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetCropGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCropGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cropName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetCropGroupsRequest}
 */
proto.datalake.GetCropGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetCropGroupsRequest;
  return proto.datalake.GetCropGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetCropGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetCropGroupsRequest}
 */
proto.datalake.GetCropGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCropName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetCropGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetCropGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetCropGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCropGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCropName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string crop_name = 1;
 * @return {string}
 */
proto.datalake.GetCropGroupsRequest.prototype.getCropName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetCropGroupsRequest} returns this
 */
proto.datalake.GetCropGroupsRequest.prototype.setCropName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.GetCropGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetCropGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetCropGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetCropGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCropGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.datalake.GroupInfo.toObject, includeInstance),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetCropGroupsResponse}
 */
proto.datalake.GetCropGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetCropGroupsResponse;
  return proto.datalake.GetCropGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetCropGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetCropGroupsResponse}
 */
proto.datalake.GetCropGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.GroupInfo;
      reader.readMessage(value,proto.datalake.GroupInfo.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetCropGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetCropGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetCropGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCropGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.GroupInfo.serializeBinaryToWriter
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated GroupInfo groups = 1;
 * @return {!Array<!proto.datalake.GroupInfo>}
 */
proto.datalake.GetCropGroupsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.datalake.GroupInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.GroupInfo, 1));
};


/**
 * @param {!Array<!proto.datalake.GroupInfo>} value
 * @return {!proto.datalake.GetCropGroupsResponse} returns this
*/
proto.datalake.GetCropGroupsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.GroupInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.GroupInfo}
 */
proto.datalake.GetCropGroupsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.GroupInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.GetCropGroupsResponse} returns this
 */
proto.datalake.GetCropGroupsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.GetCropGroupsResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.GetCropGroupsResponse} returns this
 */
proto.datalake.GetCropGroupsResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.datalake.AddAnnotationsToBatchRequest.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.datalake.AddAnnotationsToBatchRequest.JsonInputCase = {
  JSON_INPUT_NOT_SET: 0,
  JSON_FILE_CONTENT: 4,
  JSON_S3_URI: 5
};

/**
 * @return {proto.datalake.AddAnnotationsToBatchRequest.JsonInputCase}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getJsonInputCase = function() {
  return /** @type {proto.datalake.AddAnnotationsToBatchRequest.JsonInputCase} */(jspb.Message.computeOneofCase(this, proto.datalake.AddAnnotationsToBatchRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.AddAnnotationsToBatchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.AddAnnotationsToBatchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAnnotationsToBatchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    batchId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    s3Uri: jspb.Message.getFieldWithDefault(msg, 2, ""),
    annotationFormat: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jsonFileContent: msg.getJsonFileContent_asB64(),
    jsonS3Uri: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.AddAnnotationsToBatchRequest}
 */
proto.datalake.AddAnnotationsToBatchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.AddAnnotationsToBatchRequest;
  return proto.datalake.AddAnnotationsToBatchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.AddAnnotationsToBatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.AddAnnotationsToBatchRequest}
 */
proto.datalake.AddAnnotationsToBatchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Uri(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnotationFormat(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setJsonFileContent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonS3Uri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.AddAnnotationsToBatchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.AddAnnotationsToBatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAnnotationsToBatchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatchId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getS3Uri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnnotationFormat();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string batch_id = 1;
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getBatchId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAnnotationsToBatchRequest} returns this
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.setBatchId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string s3_uri = 2;
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAnnotationsToBatchRequest} returns this
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.setS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string annotation_format = 3;
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getAnnotationFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAnnotationsToBatchRequest} returns this
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.setAnnotationFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes json_file_content = 4;
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getJsonFileContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes json_file_content = 4;
 * This is a type-conversion wrapper around `getJsonFileContent()`
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getJsonFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getJsonFileContent()));
};


/**
 * optional bytes json_file_content = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getJsonFileContent()`
 * @return {!Uint8Array}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getJsonFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getJsonFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.datalake.AddAnnotationsToBatchRequest} returns this
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.setJsonFileContent = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.datalake.AddAnnotationsToBatchRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.datalake.AddAnnotationsToBatchRequest} returns this
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.clearJsonFileContent = function() {
  return jspb.Message.setOneofField(this, 4, proto.datalake.AddAnnotationsToBatchRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.hasJsonFileContent = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string json_s3_uri = 5;
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.getJsonS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAnnotationsToBatchRequest} returns this
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.setJsonS3Uri = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.datalake.AddAnnotationsToBatchRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.datalake.AddAnnotationsToBatchRequest} returns this
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.clearJsonS3Uri = function() {
  return jspb.Message.setOneofField(this, 5, proto.datalake.AddAnnotationsToBatchRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.datalake.AddAnnotationsToBatchRequest.prototype.hasJsonS3Uri = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.AddAnnotationsToBatchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.AddAnnotationsToBatchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAnnotationsToBatchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.AddAnnotationsToBatchResponse}
 */
proto.datalake.AddAnnotationsToBatchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.AddAnnotationsToBatchResponse;
  return proto.datalake.AddAnnotationsToBatchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.AddAnnotationsToBatchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.AddAnnotationsToBatchResponse}
 */
proto.datalake.AddAnnotationsToBatchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.AddAnnotationsToBatchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.AddAnnotationsToBatchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAnnotationsToBatchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAnnotationsToBatchResponse} returns this
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAnnotationsToBatchResponse} returns this
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.AddAnnotationsToBatchResponse} returns this
 */
proto.datalake.AddAnnotationsToBatchResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GroupHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GroupHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GroupHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GroupHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    direction: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GroupHistoryRequest}
 */
proto.datalake.GroupHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GroupHistoryRequest;
  return proto.datalake.GroupHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GroupHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GroupHistoryRequest}
 */
proto.datalake.GroupHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GroupHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GroupHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GroupHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GroupHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDirection();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.datalake.GroupHistoryRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GroupHistoryRequest} returns this
 */
proto.datalake.GroupHistoryRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string direction = 2;
 * @return {string}
 */
proto.datalake.GroupHistoryRequest.prototype.getDirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GroupHistoryRequest} returns this
 */
proto.datalake.GroupHistoryRequest.prototype.setDirection = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GroupHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GroupHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GroupHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GroupHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    historyTree: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GroupHistoryResponse}
 */
proto.datalake.GroupHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GroupHistoryResponse;
  return proto.datalake.GroupHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GroupHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GroupHistoryResponse}
 */
proto.datalake.GroupHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHistoryTree(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GroupHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GroupHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GroupHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GroupHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHistoryTree();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string history_tree = 1;
 * @return {string}
 */
proto.datalake.GroupHistoryResponse.prototype.getHistoryTree = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GroupHistoryResponse} returns this
 */
proto.datalake.GroupHistoryResponse.prototype.setHistoryTree = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.GroupHistoryResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.GroupHistoryResponse} returns this
 */
proto.datalake.GroupHistoryResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.GroupHistoryResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GroupHistoryResponse} returns this
 */
proto.datalake.GroupHistoryResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetImageGSDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetImageGSDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetImageGSDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageGSDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetImageGSDRequest}
 */
proto.datalake.GetImageGSDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetImageGSDRequest;
  return proto.datalake.GetImageGSDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetImageGSDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetImageGSDRequest}
 */
proto.datalake.GetImageGSDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetImageGSDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetImageGSDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetImageGSDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageGSDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string image_name = 1;
 * @return {string}
 */
proto.datalake.GetImageGSDRequest.prototype.getImageName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetImageGSDRequest} returns this
 */
proto.datalake.GetImageGSDRequest.prototype.setImageName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetImageGSDResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetImageGSDResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetImageGSDResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageGSDResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    gsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetImageGSDResponse}
 */
proto.datalake.GetImageGSDResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetImageGSDResponse;
  return proto.datalake.GetImageGSDResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetImageGSDResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetImageGSDResponse}
 */
proto.datalake.GetImageGSDResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGsd(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetImageGSDResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetImageGSDResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetImageGSDResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageGSDResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGsd();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional double gsd = 1;
 * @return {number}
 */
proto.datalake.GetImageGSDResponse.prototype.getGsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.GetImageGSDResponse} returns this
 */
proto.datalake.GetImageGSDResponse.prototype.setGsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.GetImageGSDResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.GetImageGSDResponse} returns this
 */
proto.datalake.GetImageGSDResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.GetImageGSDResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetImageGSDResponse} returns this
 */
proto.datalake.GetImageGSDResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.UpdateImagesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.UpdateImagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.UpdateImagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.UpdateImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.UpdateImagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateCriteriaList: jspb.Message.toObjectList(msg.getUpdateCriteriaList(),
    proto.datalake.KeyValue.toObject, includeInstance),
    awsAccessKeyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    awsSecretAccessKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.UpdateImagesRequest}
 */
proto.datalake.UpdateImagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.UpdateImagesRequest;
  return proto.datalake.UpdateImagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.UpdateImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.UpdateImagesRequest}
 */
proto.datalake.UpdateImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.KeyValue;
      reader.readMessage(value,proto.datalake.KeyValue.deserializeBinaryFromReader);
      msg.addUpdateCriteria(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAwsAccessKeyId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAwsSecretAccessKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.UpdateImagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.UpdateImagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.UpdateImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.UpdateImagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateCriteriaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.KeyValue.serializeBinaryToWriter
    );
  }
  f = message.getAwsAccessKeyId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAwsSecretAccessKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated KeyValue update_criteria = 1;
 * @return {!Array<!proto.datalake.KeyValue>}
 */
proto.datalake.UpdateImagesRequest.prototype.getUpdateCriteriaList = function() {
  return /** @type{!Array<!proto.datalake.KeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.KeyValue, 1));
};


/**
 * @param {!Array<!proto.datalake.KeyValue>} value
 * @return {!proto.datalake.UpdateImagesRequest} returns this
*/
proto.datalake.UpdateImagesRequest.prototype.setUpdateCriteriaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.KeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.KeyValue}
 */
proto.datalake.UpdateImagesRequest.prototype.addUpdateCriteria = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.KeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.UpdateImagesRequest} returns this
 */
proto.datalake.UpdateImagesRequest.prototype.clearUpdateCriteriaList = function() {
  return this.setUpdateCriteriaList([]);
};


/**
 * optional string aws_access_key_id = 2;
 * @return {string}
 */
proto.datalake.UpdateImagesRequest.prototype.getAwsAccessKeyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.UpdateImagesRequest} returns this
 */
proto.datalake.UpdateImagesRequest.prototype.setAwsAccessKeyId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string aws_secret_access_key = 3;
 * @return {string}
 */
proto.datalake.UpdateImagesRequest.prototype.getAwsSecretAccessKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.UpdateImagesRequest} returns this
 */
proto.datalake.UpdateImagesRequest.prototype.setAwsSecretAccessKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.UpdateImagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.UpdateImagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.UpdateImagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.UpdateImagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.UpdateImagesResponse}
 */
proto.datalake.UpdateImagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.UpdateImagesResponse;
  return proto.datalake.UpdateImagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.UpdateImagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.UpdateImagesResponse}
 */
proto.datalake.UpdateImagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.UpdateImagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.UpdateImagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.UpdateImagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.UpdateImagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.UpdateImagesResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.UpdateImagesResponse} returns this
 */
proto.datalake.UpdateImagesResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.UpdateImagesResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.UpdateImagesResponse} returns this
 */
proto.datalake.UpdateImagesResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.UpdateImagesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.UpdateImagesResponse} returns this
 */
proto.datalake.UpdateImagesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.DeleteImagesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.DeleteImagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.DeleteImagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.DeleteImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DeleteImagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deleteCriteriaList: jspb.Message.toObjectList(msg.getDeleteCriteriaList(),
    proto.datalake.KeyValue.toObject, includeInstance),
    awsAccessKeyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    awsSecretAccessKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.DeleteImagesRequest}
 */
proto.datalake.DeleteImagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.DeleteImagesRequest;
  return proto.datalake.DeleteImagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.DeleteImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.DeleteImagesRequest}
 */
proto.datalake.DeleteImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.KeyValue;
      reader.readMessage(value,proto.datalake.KeyValue.deserializeBinaryFromReader);
      msg.addDeleteCriteria(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAwsAccessKeyId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAwsSecretAccessKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.DeleteImagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.DeleteImagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.DeleteImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DeleteImagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeleteCriteriaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.KeyValue.serializeBinaryToWriter
    );
  }
  f = message.getAwsAccessKeyId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAwsSecretAccessKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated KeyValue delete_criteria = 1;
 * @return {!Array<!proto.datalake.KeyValue>}
 */
proto.datalake.DeleteImagesRequest.prototype.getDeleteCriteriaList = function() {
  return /** @type{!Array<!proto.datalake.KeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.KeyValue, 1));
};


/**
 * @param {!Array<!proto.datalake.KeyValue>} value
 * @return {!proto.datalake.DeleteImagesRequest} returns this
*/
proto.datalake.DeleteImagesRequest.prototype.setDeleteCriteriaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.KeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.KeyValue}
 */
proto.datalake.DeleteImagesRequest.prototype.addDeleteCriteria = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.KeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.DeleteImagesRequest} returns this
 */
proto.datalake.DeleteImagesRequest.prototype.clearDeleteCriteriaList = function() {
  return this.setDeleteCriteriaList([]);
};


/**
 * optional string aws_access_key_id = 2;
 * @return {string}
 */
proto.datalake.DeleteImagesRequest.prototype.getAwsAccessKeyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DeleteImagesRequest} returns this
 */
proto.datalake.DeleteImagesRequest.prototype.setAwsAccessKeyId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string aws_secret_access_key = 3;
 * @return {string}
 */
proto.datalake.DeleteImagesRequest.prototype.getAwsSecretAccessKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DeleteImagesRequest} returns this
 */
proto.datalake.DeleteImagesRequest.prototype.setAwsSecretAccessKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.DeleteImagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.DeleteImagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.DeleteImagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DeleteImagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.DeleteImagesResponse}
 */
proto.datalake.DeleteImagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.DeleteImagesResponse;
  return proto.datalake.DeleteImagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.DeleteImagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.DeleteImagesResponse}
 */
proto.datalake.DeleteImagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.DeleteImagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.DeleteImagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.DeleteImagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DeleteImagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.DeleteImagesResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DeleteImagesResponse} returns this
 */
proto.datalake.DeleteImagesResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.DeleteImagesResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DeleteImagesResponse} returns this
 */
proto.datalake.DeleteImagesResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.DeleteImagesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.DeleteImagesResponse} returns this
 */
proto.datalake.DeleteImagesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.RegisterImagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.RegisterImagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.RegisterImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterImagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    s3Uri: jspb.Message.getFieldWithDefault(msg, 1, ""),
    licenseCategory: jspb.Message.getFieldWithDefault(msg, 2, ""),
    licenseType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.RegisterImagesRequest}
 */
proto.datalake.RegisterImagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.RegisterImagesRequest;
  return proto.datalake.RegisterImagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.RegisterImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.RegisterImagesRequest}
 */
proto.datalake.RegisterImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Uri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLicenseCategory(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLicenseType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.RegisterImagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.RegisterImagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.RegisterImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterImagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getS3Uri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLicenseCategory();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLicenseType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string s3_uri = 1;
 * @return {string}
 */
proto.datalake.RegisterImagesRequest.prototype.getS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterImagesRequest} returns this
 */
proto.datalake.RegisterImagesRequest.prototype.setS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string license_category = 2;
 * @return {string}
 */
proto.datalake.RegisterImagesRequest.prototype.getLicenseCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterImagesRequest} returns this
 */
proto.datalake.RegisterImagesRequest.prototype.setLicenseCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string license_type = 3;
 * @return {string}
 */
proto.datalake.RegisterImagesRequest.prototype.getLicenseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterImagesRequest} returns this
 */
proto.datalake.RegisterImagesRequest.prototype.setLicenseType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.RegisterImagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.RegisterImagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.RegisterImagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterImagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.RegisterImagesResponse}
 */
proto.datalake.RegisterImagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.RegisterImagesResponse;
  return proto.datalake.RegisterImagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.RegisterImagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.RegisterImagesResponse}
 */
proto.datalake.RegisterImagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.RegisterImagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.RegisterImagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.RegisterImagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterImagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.RegisterImagesResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterImagesResponse} returns this
 */
proto.datalake.RegisterImagesResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.RegisterImagesResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterImagesResponse} returns this
 */
proto.datalake.RegisterImagesResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.RegisterImagesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.RegisterImagesResponse} returns this
 */
proto.datalake.RegisterImagesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetImageMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetImageMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetImageMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetImageMetadataRequest}
 */
proto.datalake.GetImageMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetImageMetadataRequest;
  return proto.datalake.GetImageMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetImageMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetImageMetadataRequest}
 */
proto.datalake.GetImageMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetImageMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetImageMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetImageMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string image_name = 1;
 * @return {string}
 */
proto.datalake.GetImageMetadataRequest.prototype.getImageName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetImageMetadataRequest} returns this
 */
proto.datalake.GetImageMetadataRequest.prototype.setImageName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetImageMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetImageMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetImageMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetImageMetadataResponse}
 */
proto.datalake.GetImageMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetImageMetadataResponse;
  return proto.datalake.GetImageMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetImageMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetImageMetadataResponse}
 */
proto.datalake.GetImageMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetImageMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetImageMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetImageMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetImageMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * map<string, string> metadata = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.datalake.GetImageMetadataResponse.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.datalake.GetImageMetadataResponse} returns this
 */
proto.datalake.GetImageMetadataResponse.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.GetImageMetadataResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.GetImageMetadataResponse} returns this
 */
proto.datalake.GetImageMetadataResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.GetImageMetadataResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetImageMetadataResponse} returns this
 */
proto.datalake.GetImageMetadataResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetCollectionMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetCollectionMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetCollectionMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCollectionMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    s3Uri: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetCollectionMetadataRequest}
 */
proto.datalake.GetCollectionMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetCollectionMetadataRequest;
  return proto.datalake.GetCollectionMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetCollectionMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetCollectionMetadataRequest}
 */
proto.datalake.GetCollectionMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Uri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetCollectionMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetCollectionMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetCollectionMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCollectionMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getS3Uri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string s3_uri = 1;
 * @return {string}
 */
proto.datalake.GetCollectionMetadataRequest.prototype.getS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetCollectionMetadataRequest} returns this
 */
proto.datalake.GetCollectionMetadataRequest.prototype.setS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetCollectionMetadataTextRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetCollectionMetadataTextRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetCollectionMetadataTextRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCollectionMetadataTextRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    textFileContent: msg.getTextFileContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetCollectionMetadataTextRequest}
 */
proto.datalake.GetCollectionMetadataTextRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetCollectionMetadataTextRequest;
  return proto.datalake.GetCollectionMetadataTextRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetCollectionMetadataTextRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetCollectionMetadataTextRequest}
 */
proto.datalake.GetCollectionMetadataTextRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setTextFileContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetCollectionMetadataTextRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetCollectionMetadataTextRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetCollectionMetadataTextRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCollectionMetadataTextRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTextFileContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes text_file_content = 1;
 * @return {string}
 */
proto.datalake.GetCollectionMetadataTextRequest.prototype.getTextFileContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes text_file_content = 1;
 * This is a type-conversion wrapper around `getTextFileContent()`
 * @return {string}
 */
proto.datalake.GetCollectionMetadataTextRequest.prototype.getTextFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getTextFileContent()));
};


/**
 * optional bytes text_file_content = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTextFileContent()`
 * @return {!Uint8Array}
 */
proto.datalake.GetCollectionMetadataTextRequest.prototype.getTextFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getTextFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.datalake.GetCollectionMetadataTextRequest} returns this
 */
proto.datalake.GetCollectionMetadataTextRequest.prototype.setTextFileContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetCollectionMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetCollectionMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetCollectionMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCollectionMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csvData: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetCollectionMetadataResponse}
 */
proto.datalake.GetCollectionMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetCollectionMetadataResponse;
  return proto.datalake.GetCollectionMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetCollectionMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetCollectionMetadataResponse}
 */
proto.datalake.GetCollectionMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsvData(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetCollectionMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetCollectionMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetCollectionMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetCollectionMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsvData();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string csv_data = 1;
 * @return {string}
 */
proto.datalake.GetCollectionMetadataResponse.prototype.getCsvData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetCollectionMetadataResponse} returns this
 */
proto.datalake.GetCollectionMetadataResponse.prototype.setCsvData = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.GetCollectionMetadataResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.GetCollectionMetadataResponse} returns this
 */
proto.datalake.GetCollectionMetadataResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.GetCollectionMetadataResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetCollectionMetadataResponse} returns this
 */
proto.datalake.GetCollectionMetadataResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.QueryInGroupRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.QueryInGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.QueryInGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.QueryInGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryInGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    queryCriteriaList: jspb.Message.toObjectList(msg.getQueryCriteriaList(),
    proto.datalake.KeyValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.QueryInGroupRequest}
 */
proto.datalake.QueryInGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.QueryInGroupRequest;
  return proto.datalake.QueryInGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.QueryInGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.QueryInGroupRequest}
 */
proto.datalake.QueryInGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = new proto.datalake.KeyValue;
      reader.readMessage(value,proto.datalake.KeyValue.deserializeBinaryFromReader);
      msg.addQueryCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.QueryInGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.QueryInGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.QueryInGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryInGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQueryCriteriaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.datalake.KeyValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.datalake.QueryInGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.QueryInGroupRequest} returns this
 */
proto.datalake.QueryInGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated KeyValue query_criteria = 2;
 * @return {!Array<!proto.datalake.KeyValue>}
 */
proto.datalake.QueryInGroupRequest.prototype.getQueryCriteriaList = function() {
  return /** @type{!Array<!proto.datalake.KeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.KeyValue, 2));
};


/**
 * @param {!Array<!proto.datalake.KeyValue>} value
 * @return {!proto.datalake.QueryInGroupRequest} returns this
*/
proto.datalake.QueryInGroupRequest.prototype.setQueryCriteriaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.datalake.KeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.KeyValue}
 */
proto.datalake.QueryInGroupRequest.prototype.addQueryCriteria = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.datalake.KeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.QueryInGroupRequest} returns this
 */
proto.datalake.QueryInGroupRequest.prototype.clearQueryCriteriaList = function() {
  return this.setQueryCriteriaList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.QueryInGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.QueryInGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.QueryInGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryInGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    s3Location: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.QueryInGroupResponse}
 */
proto.datalake.QueryInGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.QueryInGroupResponse;
  return proto.datalake.QueryInGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.QueryInGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.QueryInGroupResponse}
 */
proto.datalake.QueryInGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Location(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.QueryInGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.QueryInGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.QueryInGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.QueryInGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getS3Location();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string s3_location = 1;
 * @return {string}
 */
proto.datalake.QueryInGroupResponse.prototype.getS3Location = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.QueryInGroupResponse} returns this
 */
proto.datalake.QueryInGroupResponse.prototype.setS3Location = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.QueryInGroupResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.QueryInGroupResponse} returns this
 */
proto.datalake.QueryInGroupResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.QueryInGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.QueryInGroupResponse} returns this
 */
proto.datalake.QueryInGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetGroupMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetGroupMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetGroupMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetGroupMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetGroupMetadataRequest}
 */
proto.datalake.GetGroupMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetGroupMetadataRequest;
  return proto.datalake.GetGroupMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetGroupMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetGroupMetadataRequest}
 */
proto.datalake.GetGroupMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetGroupMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetGroupMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetGroupMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetGroupMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.datalake.GetGroupMetadataRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetGroupMetadataRequest} returns this
 */
proto.datalake.GetGroupMetadataRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.GetGroupMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.GetGroupMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.GetGroupMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetGroupMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csvData: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.GetGroupMetadataResponse}
 */
proto.datalake.GetGroupMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.GetGroupMetadataResponse;
  return proto.datalake.GetGroupMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.GetGroupMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.GetGroupMetadataResponse}
 */
proto.datalake.GetGroupMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsvData(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.GetGroupMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.GetGroupMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.GetGroupMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.GetGroupMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsvData();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string csv_data = 1;
 * @return {string}
 */
proto.datalake.GetGroupMetadataResponse.prototype.getCsvData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetGroupMetadataResponse} returns this
 */
proto.datalake.GetGroupMetadataResponse.prototype.setCsvData = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.GetGroupMetadataResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.GetGroupMetadataResponse} returns this
 */
proto.datalake.GetGroupMetadataResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.GetGroupMetadataResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.GetGroupMetadataResponse} returns this
 */
proto.datalake.GetGroupMetadataResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.datalake.RegisterDatasetRequest.oneofGroups_ = [[7,8]];

/**
 * @enum {number}
 */
proto.datalake.RegisterDatasetRequest.BatchIdsInputCase = {
  BATCH_IDS_INPUT_NOT_SET: 0,
  CSV_FILE_CONTENT: 7,
  CSV_S3_URI: 8
};

/**
 * @return {proto.datalake.RegisterDatasetRequest.BatchIdsInputCase}
 */
proto.datalake.RegisterDatasetRequest.prototype.getBatchIdsInputCase = function() {
  return /** @type {proto.datalake.RegisterDatasetRequest.BatchIdsInputCase} */(jspb.Message.computeOneofCase(this, proto.datalake.RegisterDatasetRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.RegisterDatasetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.RegisterDatasetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.RegisterDatasetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterDatasetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataS3: jspb.Message.getFieldWithDefault(msg, 1, ""),
    uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    datasetInfo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    datasetName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    classesNumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
    annotationType: jspb.Message.getFieldWithDefault(msg, 6, ""),
    csvFileContent: msg.getCsvFileContent_asB64(),
    csvS3Uri: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.RegisterDatasetRequest}
 */
proto.datalake.RegisterDatasetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.RegisterDatasetRequest;
  return proto.datalake.RegisterDatasetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.RegisterDatasetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.RegisterDatasetRequest}
 */
proto.datalake.RegisterDatasetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataS3(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDatasetInfo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDatasetName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClassesNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnotationType(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCsvFileContent(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsvS3Uri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.RegisterDatasetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.RegisterDatasetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.RegisterDatasetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterDatasetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataS3();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDatasetInfo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDatasetName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClassesNumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAnnotationType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBytes(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string data_s3 = 1;
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getDataS3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setDataS3 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string dataset_info = 3;
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getDatasetInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setDatasetInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string dataset_name = 4;
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getDatasetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setDatasetName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 classes_number = 5;
 * @return {number}
 */
proto.datalake.RegisterDatasetRequest.prototype.getClassesNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setClassesNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string annotation_type = 6;
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getAnnotationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setAnnotationType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bytes csv_file_content = 7;
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getCsvFileContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes csv_file_content = 7;
 * This is a type-conversion wrapper around `getCsvFileContent()`
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getCsvFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCsvFileContent()));
};


/**
 * optional bytes csv_file_content = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCsvFileContent()`
 * @return {!Uint8Array}
 */
proto.datalake.RegisterDatasetRequest.prototype.getCsvFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCsvFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setCsvFileContent = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.datalake.RegisterDatasetRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.clearCsvFileContent = function() {
  return jspb.Message.setOneofField(this, 7, proto.datalake.RegisterDatasetRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.datalake.RegisterDatasetRequest.prototype.hasCsvFileContent = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string csv_s3_uri = 8;
 * @return {string}
 */
proto.datalake.RegisterDatasetRequest.prototype.getCsvS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.setCsvS3Uri = function(value) {
  return jspb.Message.setOneofField(this, 8, proto.datalake.RegisterDatasetRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.datalake.RegisterDatasetRequest} returns this
 */
proto.datalake.RegisterDatasetRequest.prototype.clearCsvS3Uri = function() {
  return jspb.Message.setOneofField(this, 8, proto.datalake.RegisterDatasetRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.datalake.RegisterDatasetRequest.prototype.hasCsvS3Uri = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.RegisterDatasetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.RegisterDatasetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.RegisterDatasetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterDatasetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    datasetId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.RegisterDatasetResponse}
 */
proto.datalake.RegisterDatasetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.RegisterDatasetResponse;
  return proto.datalake.RegisterDatasetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.RegisterDatasetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.RegisterDatasetResponse}
 */
proto.datalake.RegisterDatasetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDatasetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.RegisterDatasetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.RegisterDatasetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.RegisterDatasetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.RegisterDatasetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getDatasetId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.RegisterDatasetResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetResponse} returns this
 */
proto.datalake.RegisterDatasetResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.RegisterDatasetResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetResponse} returns this
 */
proto.datalake.RegisterDatasetResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.RegisterDatasetResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.RegisterDatasetResponse} returns this
 */
proto.datalake.RegisterDatasetResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string dataset_id = 4;
 * @return {string}
 */
proto.datalake.RegisterDatasetResponse.prototype.getDatasetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.RegisterDatasetResponse} returns this
 */
proto.datalake.RegisterDatasetResponse.prototype.setDatasetId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PullDatasetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PullDatasetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PullDatasetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullDatasetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    datasetId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PullDatasetRequest}
 */
proto.datalake.PullDatasetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PullDatasetRequest;
  return proto.datalake.PullDatasetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PullDatasetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PullDatasetRequest}
 */
proto.datalake.PullDatasetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDatasetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PullDatasetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PullDatasetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PullDatasetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullDatasetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDatasetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string dataset_id = 1;
 * @return {string}
 */
proto.datalake.PullDatasetRequest.prototype.getDatasetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PullDatasetRequest} returns this
 */
proto.datalake.PullDatasetRequest.prototype.setDatasetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PullDatasetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PullDatasetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PullDatasetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullDatasetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    s3Location: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PullDatasetResponse}
 */
proto.datalake.PullDatasetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PullDatasetResponse;
  return proto.datalake.PullDatasetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PullDatasetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PullDatasetResponse}
 */
proto.datalake.PullDatasetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Location(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PullDatasetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PullDatasetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PullDatasetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PullDatasetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getS3Location();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string s3_location = 1;
 * @return {string}
 */
proto.datalake.PullDatasetResponse.prototype.getS3Location = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PullDatasetResponse} returns this
 */
proto.datalake.PullDatasetResponse.prototype.setS3Location = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.datalake.PullDatasetResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.PullDatasetResponse} returns this
 */
proto.datalake.PullDatasetResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.datalake.PullDatasetResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PullDatasetResponse} returns this
 */
proto.datalake.PullDatasetResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.datalake.AddAugmentationRequest.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.datalake.AddAugmentationRequest.JsonInputCase = {
  JSON_INPUT_NOT_SET: 0,
  JSON_FILE_CONTENT: 4,
  JSON_S3_URI: 5
};

/**
 * @return {proto.datalake.AddAugmentationRequest.JsonInputCase}
 */
proto.datalake.AddAugmentationRequest.prototype.getJsonInputCase = function() {
  return /** @type {proto.datalake.AddAugmentationRequest.JsonInputCase} */(jspb.Message.computeOneofCase(this, proto.datalake.AddAugmentationRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.AddAugmentationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.AddAugmentationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.AddAugmentationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAugmentationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    datasetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    gitCommitLink: jspb.Message.getFieldWithDefault(msg, 2, ""),
    randomSeed: jspb.Message.getFieldWithDefault(msg, 3, 0),
    jsonFileContent: msg.getJsonFileContent_asB64(),
    jsonS3Uri: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.AddAugmentationRequest}
 */
proto.datalake.AddAugmentationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.AddAugmentationRequest;
  return proto.datalake.AddAugmentationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.AddAugmentationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.AddAugmentationRequest}
 */
proto.datalake.AddAugmentationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDatasetId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGitCommitLink(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRandomSeed(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setJsonFileContent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonS3Uri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.AddAugmentationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.AddAugmentationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.AddAugmentationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAugmentationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDatasetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGitCommitLink();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRandomSeed();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string dataset_id = 1;
 * @return {string}
 */
proto.datalake.AddAugmentationRequest.prototype.getDatasetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAugmentationRequest} returns this
 */
proto.datalake.AddAugmentationRequest.prototype.setDatasetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string git_commit_link = 2;
 * @return {string}
 */
proto.datalake.AddAugmentationRequest.prototype.getGitCommitLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAugmentationRequest} returns this
 */
proto.datalake.AddAugmentationRequest.prototype.setGitCommitLink = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 random_seed = 3;
 * @return {number}
 */
proto.datalake.AddAugmentationRequest.prototype.getRandomSeed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.AddAugmentationRequest} returns this
 */
proto.datalake.AddAugmentationRequest.prototype.setRandomSeed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes json_file_content = 4;
 * @return {string}
 */
proto.datalake.AddAugmentationRequest.prototype.getJsonFileContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes json_file_content = 4;
 * This is a type-conversion wrapper around `getJsonFileContent()`
 * @return {string}
 */
proto.datalake.AddAugmentationRequest.prototype.getJsonFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getJsonFileContent()));
};


/**
 * optional bytes json_file_content = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getJsonFileContent()`
 * @return {!Uint8Array}
 */
proto.datalake.AddAugmentationRequest.prototype.getJsonFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getJsonFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.datalake.AddAugmentationRequest} returns this
 */
proto.datalake.AddAugmentationRequest.prototype.setJsonFileContent = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.datalake.AddAugmentationRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.datalake.AddAugmentationRequest} returns this
 */
proto.datalake.AddAugmentationRequest.prototype.clearJsonFileContent = function() {
  return jspb.Message.setOneofField(this, 4, proto.datalake.AddAugmentationRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.datalake.AddAugmentationRequest.prototype.hasJsonFileContent = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string json_s3_uri = 5;
 * @return {string}
 */
proto.datalake.AddAugmentationRequest.prototype.getJsonS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAugmentationRequest} returns this
 */
proto.datalake.AddAugmentationRequest.prototype.setJsonS3Uri = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.datalake.AddAugmentationRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.datalake.AddAugmentationRequest} returns this
 */
proto.datalake.AddAugmentationRequest.prototype.clearJsonS3Uri = function() {
  return jspb.Message.setOneofField(this, 5, proto.datalake.AddAugmentationRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.datalake.AddAugmentationRequest.prototype.hasJsonS3Uri = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.AddAugmentationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.AddAugmentationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.AddAugmentationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAugmentationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loggerUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.AddAugmentationResponse}
 */
proto.datalake.AddAugmentationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.AddAugmentationResponse;
  return proto.datalake.AddAugmentationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.AddAugmentationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.AddAugmentationResponse}
 */
proto.datalake.AddAugmentationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoggerUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.AddAugmentationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.AddAugmentationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.AddAugmentationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.AddAugmentationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.datalake.AddAugmentationResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAugmentationResponse} returns this
 */
proto.datalake.AddAugmentationResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logger_url = 2;
 * @return {string}
 */
proto.datalake.AddAugmentationResponse.prototype.getLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.AddAugmentationResponse} returns this
 */
proto.datalake.AddAugmentationResponse.prototype.setLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.datalake.AddAugmentationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.AddAugmentationResponse} returns this
 */
proto.datalake.AddAugmentationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.DataCurationPipelineRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.DataCurationPipelineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.DataCurationPipelineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.DataCurationPipelineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DataCurationPipelineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    selectImagesCriteriaList: jspb.Message.toObjectList(msg.getSelectImagesCriteriaList(),
    proto.datalake.KeyValue.toObject, includeInstance),
    uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    creator: jspb.Message.getFieldWithDefault(msg, 3, ""),
    creatorId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    purpose: jspb.Message.getFieldWithDefault(msg, 4, ""),
    parentId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isFinal: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isOriginal: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    vendorName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    annotationType: jspb.Message.getFieldWithDefault(msg, 9, ""),
    annotationFormat: jspb.Message.getFieldWithDefault(msg, 10, ""),
    modelName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    addAnnotationsFormat: jspb.Message.getFieldWithDefault(msg, 14, ""),
    weedThresholdPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    minWeedInstanceWidth: jspb.Message.getFieldWithDefault(msg, 17, 0),
    minWeedInstanceHeight: jspb.Message.getFieldWithDefault(msg, 18, 0),
    sourcePipelineId: jspb.Message.getFieldWithDefault(msg, 19, ""),
    sourceBatchId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    localDirectoryPath: jspb.Message.getFieldWithDefault(msg, 21, ""),
    saveDestination: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.DataCurationPipelineRequest}
 */
proto.datalake.DataCurationPipelineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.DataCurationPipelineRequest;
  return proto.datalake.DataCurationPipelineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.DataCurationPipelineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.DataCurationPipelineRequest}
 */
proto.datalake.DataCurationPipelineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.KeyValue;
      reader.readMessage(value,proto.datalake.KeyValue.deserializeBinaryFromReader);
      msg.addSelectImagesCriteria(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurpose(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFinal(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOriginal(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnotationType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnotationFormat(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddAnnotationsFormat(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWeedThresholdPercentage(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinWeedInstanceWidth(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinWeedInstanceHeight(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourcePipelineId(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceBatchId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalDirectoryPath(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaveDestination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.DataCurationPipelineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.DataCurationPipelineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.DataCurationPipelineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DataCurationPipelineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSelectImagesCriteriaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.KeyValue.serializeBinaryToWriter
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatorId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPurpose();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsFinal();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsOriginal();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getVendorName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAnnotationType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAnnotationFormat();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAddAnnotationsFormat();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getWeedThresholdPercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      16,
      f
    );
  }
  f = message.getMinWeedInstanceWidth();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getMinWeedInstanceHeight();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getSourcePipelineId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSourceBatchId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getLocalDirectoryPath();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getSaveDestination();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * repeated KeyValue select_images_criteria = 1;
 * @return {!Array<!proto.datalake.KeyValue>}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getSelectImagesCriteriaList = function() {
  return /** @type{!Array<!proto.datalake.KeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.KeyValue, 1));
};


/**
 * @param {!Array<!proto.datalake.KeyValue>} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
*/
proto.datalake.DataCurationPipelineRequest.prototype.setSelectImagesCriteriaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.KeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.KeyValue}
 */
proto.datalake.DataCurationPipelineRequest.prototype.addSelectImagesCriteria = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.KeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.clearSelectImagesCriteriaList = function() {
  return this.setSelectImagesCriteriaList([]);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string creator = 3;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string creator_id = 13;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getCreatorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setCreatorId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string purpose = 4;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getPurpose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string parent_id = 5;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_final = 6;
 * @return {boolean}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getIsFinal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setIsFinal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_original = 7;
 * @return {boolean}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getIsOriginal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setIsOriginal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string vendor_name = 8;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getVendorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setVendorName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string annotation_type = 9;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getAnnotationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setAnnotationType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string annotation_format = 10;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getAnnotationFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setAnnotationFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string model_name = 12;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string add_annotations_format = 14;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getAddAnnotationsFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setAddAnnotationsFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional float weed_threshold_percentage = 16;
 * @return {number}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getWeedThresholdPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setWeedThresholdPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional int32 min_weed_instance_width = 17;
 * @return {number}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getMinWeedInstanceWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setMinWeedInstanceWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 min_weed_instance_height = 18;
 * @return {number}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getMinWeedInstanceHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setMinWeedInstanceHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string source_pipeline_id = 19;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getSourcePipelineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setSourcePipelineId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string source_batch_id = 20;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getSourceBatchId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setSourceBatchId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string local_directory_path = 21;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getLocalDirectoryPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setLocalDirectoryPath = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string save_destination = 22;
 * @return {string}
 */
proto.datalake.DataCurationPipelineRequest.prototype.getSaveDestination = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineRequest} returns this
 */
proto.datalake.DataCurationPipelineRequest.prototype.setSaveDestination = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.DataCurationPipelineResponse.repeatedFields_ = [12,16,22];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.DataCurationPipelineResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.DataCurationPipelineResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.DataCurationPipelineResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DataCurationPipelineResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateType: jspb.Message.getFieldWithDefault(msg, 25, 0),
    currentStep: jspb.Message.getFieldWithDefault(msg, 26, 0),
    currentStepName: jspb.Message.getFieldWithDefault(msg, 27, ""),
    progressPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
    selectImagesMessage: jspb.Message.getFieldWithDefault(msg, 1, ""),
    selectImagesS3Uri: jspb.Message.getFieldWithDefault(msg, 2, ""),
    selectImagesLoggerUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    workspaceDirectoryUrl: jspb.Message.getFieldWithDefault(msg, 31, ""),
    registerBatchMessage: jspb.Message.getFieldWithDefault(msg, 4, ""),
    registerBatchLoggerUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    batchId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    bulkPredictMessage: jspb.Message.getFieldWithDefault(msg, 10, ""),
    bulkPredictProcessedCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    bulkPredictResponsesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    seedOutputUrl: jspb.Message.getFieldWithDefault(msg, 30, ""),
    addAnnotationsMessage: jspb.Message.getFieldWithDefault(msg, 13, ""),
    addAnnotationsLoggerUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
    batchInsightsQuery: jspb.Message.getFieldWithDefault(msg, 15, ""),
    batchInsightsResultsList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    batchInsightsCount: jspb.Message.getFieldWithDefault(msg, 17, 0),
    downloadedImagesPath: jspb.Message.getFieldWithDefault(msg, 18, ""),
    downloadedImagesCount: jspb.Message.getFieldWithDefault(msg, 19, 0),
    weedInstancesMessage: jspb.Message.getFieldWithDefault(msg, 29, ""),
    highWeedImagesCount: jspb.Message.getFieldWithDefault(msg, 20, 0),
    weedInstancesExtracted: jspb.Message.getFieldWithDefault(msg, 21, 0),
    highWeedImageIdsList: (f = jspb.Message.getRepeatedField(msg, 22)) == null ? undefined : f,
    weedExtractsPath: jspb.Message.getFieldWithDefault(msg, 23, ""),
    weedExtractsS3Uri: jspb.Message.getFieldWithDefault(msg, 24, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 8, ""),
    pipelineStage: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.DataCurationPipelineResponse}
 */
proto.datalake.DataCurationPipelineResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.DataCurationPipelineResponse;
  return proto.datalake.DataCurationPipelineResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.DataCurationPipelineResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.DataCurationPipelineResponse}
 */
proto.datalake.DataCurationPipelineResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 25:
      var value = /** @type {!proto.datalake.DataCurationPipelineResponse.UpdateType} */ (reader.readEnum());
      msg.setUpdateType(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentStep(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentStepName(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setProgressPercentage(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSelectImagesMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSelectImagesS3Uri(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSelectImagesLoggerUrl(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceDirectoryUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisterBatchMessage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisterBatchLoggerUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBulkPredictMessage(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBulkPredictProcessedCount(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addBulkPredictResponses(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeedOutputUrl(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddAnnotationsMessage(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddAnnotationsLoggerUrl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchInsightsQuery(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addBatchInsightsResults(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBatchInsightsCount(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadedImagesPath(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDownloadedImagesCount(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeedInstancesMessage(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHighWeedImagesCount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWeedInstancesExtracted(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.addHighWeedImageIds(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeedExtractsPath(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeedExtractsS3Uri(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPipelineStage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.DataCurationPipelineResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.DataCurationPipelineResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.DataCurationPipelineResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.DataCurationPipelineResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateType();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getCurrentStep();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getCurrentStepName();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getProgressPercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      28,
      f
    );
  }
  f = message.getSelectImagesMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSelectImagesS3Uri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSelectImagesLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWorkspaceDirectoryUrl();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getRegisterBatchMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRegisterBatchLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBatchId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBulkPredictMessage();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBulkPredictProcessedCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getBulkPredictResponsesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getSeedOutputUrl();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getAddAnnotationsMessage();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAddAnnotationsLoggerUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBatchInsightsQuery();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBatchInsightsResultsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getBatchInsightsCount();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getDownloadedImagesPath();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getDownloadedImagesCount();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getWeedInstancesMessage();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getHighWeedImagesCount();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getWeedInstancesExtracted();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getHighWeedImageIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      22,
      f
    );
  }
  f = message.getWeedExtractsPath();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getWeedExtractsS3Uri();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPipelineStage();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.datalake.DataCurationPipelineResponse.UpdateType = {
  UNKNOWN: 0,
  STEP_STARTED: 1,
  STEP_PROGRESS: 2,
  STEP_COMPLETED: 3,
  PIPELINE_COMPLETED: 4,
  PIPELINE_ERROR: 5
};

/**
 * optional UpdateType update_type = 25;
 * @return {!proto.datalake.DataCurationPipelineResponse.UpdateType}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getUpdateType = function() {
  return /** @type {!proto.datalake.DataCurationPipelineResponse.UpdateType} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.datalake.DataCurationPipelineResponse.UpdateType} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setUpdateType = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional int32 current_step = 26;
 * @return {number}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getCurrentStep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setCurrentStep = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional string current_step_name = 27;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getCurrentStepName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setCurrentStepName = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional float progress_percentage = 28;
 * @return {number}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getProgressPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setProgressPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional string select_images_message = 1;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getSelectImagesMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setSelectImagesMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string select_images_s3_uri = 2;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getSelectImagesS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setSelectImagesS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string select_images_logger_url = 3;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getSelectImagesLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setSelectImagesLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string workspace_directory_url = 31;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getWorkspaceDirectoryUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setWorkspaceDirectoryUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string register_batch_message = 4;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getRegisterBatchMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setRegisterBatchMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string register_batch_logger_url = 5;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getRegisterBatchLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setRegisterBatchLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string batch_id = 6;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getBatchId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setBatchId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string bulk_predict_message = 10;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getBulkPredictMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setBulkPredictMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 bulk_predict_processed_count = 11;
 * @return {number}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getBulkPredictProcessedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setBulkPredictProcessedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated string bulk_predict_responses = 12;
 * @return {!Array<string>}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getBulkPredictResponsesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setBulkPredictResponsesList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.addBulkPredictResponses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.clearBulkPredictResponsesList = function() {
  return this.setBulkPredictResponsesList([]);
};


/**
 * optional string seed_output_url = 30;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getSeedOutputUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setSeedOutputUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string add_annotations_message = 13;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getAddAnnotationsMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setAddAnnotationsMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string add_annotations_logger_url = 14;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getAddAnnotationsLoggerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setAddAnnotationsLoggerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string batch_insights_query = 15;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getBatchInsightsQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setBatchInsightsQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated string batch_insights_results = 16;
 * @return {!Array<string>}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getBatchInsightsResultsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setBatchInsightsResultsList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.addBatchInsightsResults = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.clearBatchInsightsResultsList = function() {
  return this.setBatchInsightsResultsList([]);
};


/**
 * optional int32 batch_insights_count = 17;
 * @return {number}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getBatchInsightsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setBatchInsightsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string downloaded_images_path = 18;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getDownloadedImagesPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setDownloadedImagesPath = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 downloaded_images_count = 19;
 * @return {number}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getDownloadedImagesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setDownloadedImagesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional string weed_instances_message = 29;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getWeedInstancesMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setWeedInstancesMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional int32 high_weed_images_count = 20;
 * @return {number}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getHighWeedImagesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setHighWeedImagesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int32 weed_instances_extracted = 21;
 * @return {number}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getWeedInstancesExtracted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setWeedInstancesExtracted = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * repeated string high_weed_image_ids = 22;
 * @return {!Array<string>}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getHighWeedImageIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 22));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setHighWeedImageIdsList = function(value) {
  return jspb.Message.setField(this, 22, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.addHighWeedImageIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 22, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.clearHighWeedImageIdsList = function() {
  return this.setHighWeedImageIdsList([]);
};


/**
 * optional string weed_extracts_path = 23;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getWeedExtractsPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setWeedExtractsPath = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string weed_extracts_s3_uri = 24;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getWeedExtractsS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setWeedExtractsS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional bool success = 7;
 * @return {boolean}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string error_message = 8;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string pipeline_stage = 9;
 * @return {string}
 */
proto.datalake.DataCurationPipelineResponse.prototype.getPipelineStage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.DataCurationPipelineResponse} returns this
 */
proto.datalake.DataCurationPipelineResponse.prototype.setPipelineStage = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PipelineStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PipelineStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PipelineStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelineId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PipelineStatusRequest}
 */
proto.datalake.PipelineStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PipelineStatusRequest;
  return proto.datalake.PipelineStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PipelineStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PipelineStatusRequest}
 */
proto.datalake.PipelineStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPipelineId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PipelineStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PipelineStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PipelineStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelineId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string pipeline_id = 1;
 * @return {string}
 */
proto.datalake.PipelineStatusRequest.prototype.getPipelineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineStatusRequest} returns this
 */
proto.datalake.PipelineStatusRequest.prototype.setPipelineId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PipelineStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PipelineStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PipelineStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    currentState: (f = msg.getCurrentState()) && proto.datalake.DataCurationPipelineResponse.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 3, ""),
    overallProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    currentStep: jspb.Message.getFieldWithDefault(msg, 5, 0),
    startTime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    estimatedCompletion: jspb.Message.getFieldWithDefault(msg, 7, ""),
    endTime: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PipelineStatusResponse}
 */
proto.datalake.PipelineStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PipelineStatusResponse;
  return proto.datalake.PipelineStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PipelineStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PipelineStatusResponse}
 */
proto.datalake.PipelineStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFound(value);
      break;
    case 2:
      var value = new proto.datalake.DataCurationPipelineResponse;
      reader.readMessage(value,proto.datalake.DataCurationPipelineResponse.deserializeBinaryFromReader);
      msg.setCurrentState(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setOverallProgress(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentStep(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEstimatedCompletion(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PipelineStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PipelineStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PipelineStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCurrentState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.datalake.DataCurationPipelineResponse.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOverallProgress();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getCurrentStep();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEstimatedCompletion();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional bool found = 1;
 * @return {boolean}
 */
proto.datalake.PipelineStatusResponse.prototype.getFound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.setFound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional DataCurationPipelineResponse current_state = 2;
 * @return {?proto.datalake.DataCurationPipelineResponse}
 */
proto.datalake.PipelineStatusResponse.prototype.getCurrentState = function() {
  return /** @type{?proto.datalake.DataCurationPipelineResponse} */ (
    jspb.Message.getWrapperField(this, proto.datalake.DataCurationPipelineResponse, 2));
};


/**
 * @param {?proto.datalake.DataCurationPipelineResponse|undefined} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
*/
proto.datalake.PipelineStatusResponse.prototype.setCurrentState = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.clearCurrentState = function() {
  return this.setCurrentState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.datalake.PipelineStatusResponse.prototype.hasCurrentState = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.datalake.PipelineStatusResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional float overall_progress = 4;
 * @return {number}
 */
proto.datalake.PipelineStatusResponse.prototype.getOverallProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.setOverallProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 current_step = 5;
 * @return {number}
 */
proto.datalake.PipelineStatusResponse.prototype.getCurrentStep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.setCurrentStep = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string start_time = 6;
 * @return {string}
 */
proto.datalake.PipelineStatusResponse.prototype.getStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.setStartTime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string estimated_completion = 7;
 * @return {string}
 */
proto.datalake.PipelineStatusResponse.prototype.getEstimatedCompletion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.setEstimatedCompletion = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string end_time = 8;
 * @return {string}
 */
proto.datalake.PipelineStatusResponse.prototype.getEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineStatusResponse} returns this
 */
proto.datalake.PipelineStatusResponse.prototype.setEndTime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.WatchPipelineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.WatchPipelineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.WatchPipelineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.WatchPipelineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelineId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    replayHistory: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.WatchPipelineRequest}
 */
proto.datalake.WatchPipelineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.WatchPipelineRequest;
  return proto.datalake.WatchPipelineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.WatchPipelineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.WatchPipelineRequest}
 */
proto.datalake.WatchPipelineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPipelineId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReplayHistory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.WatchPipelineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.WatchPipelineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.WatchPipelineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.WatchPipelineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelineId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReplayHistory();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string pipeline_id = 1;
 * @return {string}
 */
proto.datalake.WatchPipelineRequest.prototype.getPipelineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.WatchPipelineRequest} returns this
 */
proto.datalake.WatchPipelineRequest.prototype.setPipelineId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool replay_history = 2;
 * @return {boolean}
 */
proto.datalake.WatchPipelineRequest.prototype.getReplayHistory = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.WatchPipelineRequest} returns this
 */
proto.datalake.WatchPipelineRequest.prototype.setReplayHistory = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.ActivePipelinesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.ActivePipelinesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.ActivePipelinesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.ActivePipelinesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.ActivePipelinesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelinesList: jspb.Message.toObjectList(msg.getPipelinesList(),
    proto.datalake.ActivePipeline.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.ActivePipelinesResponse}
 */
proto.datalake.ActivePipelinesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.ActivePipelinesResponse;
  return proto.datalake.ActivePipelinesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.ActivePipelinesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.ActivePipelinesResponse}
 */
proto.datalake.ActivePipelinesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.ActivePipeline;
      reader.readMessage(value,proto.datalake.ActivePipeline.deserializeBinaryFromReader);
      msg.addPipelines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.ActivePipelinesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.ActivePipelinesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.ActivePipelinesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.ActivePipelinesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.ActivePipeline.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivePipeline pipelines = 1;
 * @return {!Array<!proto.datalake.ActivePipeline>}
 */
proto.datalake.ActivePipelinesResponse.prototype.getPipelinesList = function() {
  return /** @type{!Array<!proto.datalake.ActivePipeline>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.ActivePipeline, 1));
};


/**
 * @param {!Array<!proto.datalake.ActivePipeline>} value
 * @return {!proto.datalake.ActivePipelinesResponse} returns this
*/
proto.datalake.ActivePipelinesResponse.prototype.setPipelinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.ActivePipeline=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.ActivePipeline}
 */
proto.datalake.ActivePipelinesResponse.prototype.addPipelines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.ActivePipeline, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.ActivePipelinesResponse} returns this
 */
proto.datalake.ActivePipelinesResponse.prototype.clearPipelinesList = function() {
  return this.setPipelinesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.ActivePipeline.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.ActivePipeline.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.ActivePipeline} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.ActivePipeline.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelineId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    creator: jspb.Message.getFieldWithDefault(msg, 2, ""),
    creatorId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    purpose: jspb.Message.getFieldWithDefault(msg, 3, ""),
    modelName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    progress: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    currentStep: jspb.Message.getFieldWithDefault(msg, 7, 0),
    startTime: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.ActivePipeline}
 */
proto.datalake.ActivePipeline.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.ActivePipeline;
  return proto.datalake.ActivePipeline.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.ActivePipeline} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.ActivePipeline}
 */
proto.datalake.ActivePipeline.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPipelineId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurpose(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setProgress(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentStep(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.ActivePipeline.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.ActivePipeline.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.ActivePipeline} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.ActivePipeline.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelineId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatorId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPurpose();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProgress();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getCurrentStep();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string pipeline_id = 1;
 * @return {string}
 */
proto.datalake.ActivePipeline.prototype.getPipelineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setPipelineId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string creator = 2;
 * @return {string}
 */
proto.datalake.ActivePipeline.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string creator_id = 9;
 * @return {string}
 */
proto.datalake.ActivePipeline.prototype.getCreatorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setCreatorId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string purpose = 3;
 * @return {string}
 */
proto.datalake.ActivePipeline.prototype.getPurpose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model_name = 4;
 * @return {string}
 */
proto.datalake.ActivePipeline.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.datalake.ActivePipeline.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional float progress = 6;
 * @return {number}
 */
proto.datalake.ActivePipeline.prototype.getProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 current_step = 7;
 * @return {number}
 */
proto.datalake.ActivePipeline.prototype.getCurrentStep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setCurrentStep = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string start_time = 8;
 * @return {string}
 */
proto.datalake.ActivePipeline.prototype.getStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.ActivePipeline} returns this
 */
proto.datalake.ActivePipeline.prototype.setStartTime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PipelineHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PipelineHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PipelineHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    creator: jspb.Message.getFieldWithDefault(msg, 1, ""),
    creatorId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    startDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PipelineHistoryRequest}
 */
proto.datalake.PipelineHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PipelineHistoryRequest;
  return proto.datalake.PipelineHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PipelineHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PipelineHistoryRequest}
 */
proto.datalake.PipelineHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PipelineHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PipelineHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PipelineHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatorId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string creator = 1;
 * @return {string}
 */
proto.datalake.PipelineHistoryRequest.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryRequest} returns this
 */
proto.datalake.PipelineHistoryRequest.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string creator_id = 5;
 * @return {string}
 */
proto.datalake.PipelineHistoryRequest.prototype.getCreatorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryRequest} returns this
 */
proto.datalake.PipelineHistoryRequest.prototype.setCreatorId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string start_date = 2;
 * @return {string}
 */
proto.datalake.PipelineHistoryRequest.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryRequest} returns this
 */
proto.datalake.PipelineHistoryRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string end_date = 3;
 * @return {string}
 */
proto.datalake.PipelineHistoryRequest.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryRequest} returns this
 */
proto.datalake.PipelineHistoryRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.datalake.PipelineHistoryRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.PipelineHistoryRequest} returns this
 */
proto.datalake.PipelineHistoryRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.datalake.PipelineHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PipelineHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PipelineHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PipelineHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelinesList: jspb.Message.toObjectList(msg.getPipelinesList(),
    proto.datalake.PipelineHistoryItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PipelineHistoryResponse}
 */
proto.datalake.PipelineHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PipelineHistoryResponse;
  return proto.datalake.PipelineHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PipelineHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PipelineHistoryResponse}
 */
proto.datalake.PipelineHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.datalake.PipelineHistoryItem;
      reader.readMessage(value,proto.datalake.PipelineHistoryItem.deserializeBinaryFromReader);
      msg.addPipelines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PipelineHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PipelineHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PipelineHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.datalake.PipelineHistoryItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PipelineHistoryItem pipelines = 1;
 * @return {!Array<!proto.datalake.PipelineHistoryItem>}
 */
proto.datalake.PipelineHistoryResponse.prototype.getPipelinesList = function() {
  return /** @type{!Array<!proto.datalake.PipelineHistoryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.datalake.PipelineHistoryItem, 1));
};


/**
 * @param {!Array<!proto.datalake.PipelineHistoryItem>} value
 * @return {!proto.datalake.PipelineHistoryResponse} returns this
*/
proto.datalake.PipelineHistoryResponse.prototype.setPipelinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.datalake.PipelineHistoryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.datalake.PipelineHistoryItem}
 */
proto.datalake.PipelineHistoryResponse.prototype.addPipelines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.datalake.PipelineHistoryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.datalake.PipelineHistoryResponse} returns this
 */
proto.datalake.PipelineHistoryResponse.prototype.clearPipelinesList = function() {
  return this.setPipelinesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.PipelineHistoryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.PipelineHistoryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.PipelineHistoryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineHistoryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelineId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    creator: jspb.Message.getFieldWithDefault(msg, 2, ""),
    creatorId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    purpose: jspb.Message.getFieldWithDefault(msg, 3, ""),
    modelName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    overallProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    startTime: jspb.Message.getFieldWithDefault(msg, 7, ""),
    endTime: jspb.Message.getFieldWithDefault(msg, 8, ""),
    durationSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    batchId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    imageCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.PipelineHistoryItem}
 */
proto.datalake.PipelineHistoryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.PipelineHistoryItem;
  return proto.datalake.PipelineHistoryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.PipelineHistoryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.PipelineHistoryItem}
 */
proto.datalake.PipelineHistoryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPipelineId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurpose(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setOverallProgress(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartTime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndTime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDurationSeconds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setImageCount(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.PipelineHistoryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.PipelineHistoryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.PipelineHistoryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.PipelineHistoryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelineId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatorId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPurpose();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOverallProgress();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDurationSeconds();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getBatchId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getImageCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string pipeline_id = 1;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getPipelineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setPipelineId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string creator = 2;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string creator_id = 13;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getCreatorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setCreatorId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string purpose = 3;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getPurpose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model_name = 4;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional float overall_progress = 6;
 * @return {number}
 */
proto.datalake.PipelineHistoryItem.prototype.getOverallProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setOverallProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string start_time = 7;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setStartTime = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string end_time = 8;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setEndTime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional float duration_seconds = 9;
 * @return {number}
 */
proto.datalake.PipelineHistoryItem.prototype.getDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setDurationSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string batch_id = 10;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getBatchId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setBatchId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 image_count = 11;
 * @return {number}
 */
proto.datalake.PipelineHistoryItem.prototype.getImageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setImageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string error_message = 12;
 * @return {string}
 */
proto.datalake.PipelineHistoryItem.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.PipelineHistoryItem} returns this
 */
proto.datalake.PipelineHistoryItem.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.CancelPipelineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.CancelPipelineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.CancelPipelineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.CancelPipelineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelineId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.CancelPipelineRequest}
 */
proto.datalake.CancelPipelineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.CancelPipelineRequest;
  return proto.datalake.CancelPipelineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.CancelPipelineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.CancelPipelineRequest}
 */
proto.datalake.CancelPipelineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPipelineId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.CancelPipelineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.CancelPipelineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.CancelPipelineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.CancelPipelineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelineId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string pipeline_id = 1;
 * @return {string}
 */
proto.datalake.CancelPipelineRequest.prototype.getPipelineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.CancelPipelineRequest} returns this
 */
proto.datalake.CancelPipelineRequest.prototype.setPipelineId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.datalake.CancelPipelineResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.datalake.CancelPipelineResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.datalake.CancelPipelineResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.CancelPipelineResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.datalake.CancelPipelineResponse}
 */
proto.datalake.CancelPipelineResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.datalake.CancelPipelineResponse;
  return proto.datalake.CancelPipelineResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.datalake.CancelPipelineResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.datalake.CancelPipelineResponse}
 */
proto.datalake.CancelPipelineResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.datalake.CancelPipelineResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.datalake.CancelPipelineResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.datalake.CancelPipelineResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.datalake.CancelPipelineResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.datalake.CancelPipelineResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.datalake.CancelPipelineResponse} returns this
 */
proto.datalake.CancelPipelineResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.datalake.CancelPipelineResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.datalake.CancelPipelineResponse} returns this
 */
proto.datalake.CancelPipelineResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.datalake);
